import { layoutOf } from '../../domain/layout';
import { dualAxle, singleAxle } from '../wheel-placements';
import {
  ForkliftBody,
  FuelBowserBody,
  MotorGraderBody,
  PneumaticTyreRollerBody,
  ServiceVehicleBody,
  TelehandlerBody,
  TractorBody,
  UndergroundDumperBody,
  UndergroundLhdBody,
  WheelDozerBody,
  WheeledCraneBody,
  WheeledDrillRigBody,
  WheeledExcavatorBody,
} from './OperationalFleetBody';

const specs = [
  ['fuel_bowser', 'fuel_bowser-10-wheel-v1', ['single', 'dual', 'dual'], [2.55, -0.85, -2.55], FuelBowserBody, 7.5],
  ['service_vehicle', 'service_vehicle-4-wheel-v1', ['single', 'single'], [1.55, -1.55], ServiceVehicleBody, 5.4],
  ['motor_grader', 'motor_grader-6-wheel-v1', ['single', 'single', 'single'], [2.9, -1.45, -2.6], MotorGraderBody, 8.2],
  ['forklift', 'forklift-4-wheel-v1', ['single', 'single'], [1.05, -1.1], ForkliftBody, 4.6],
  ['telehandler', 'telehandler-4-wheel-v1', ['single', 'single'], [1.7, -1.65], TelehandlerBody, 6.0],
  ['tractor', 'tractor-4-wheel-v1', ['single', 'single'], [1.45, -1.45], TractorBody, 5.1],
  ['underground_lhd', 'underground_lhd-4-wheel-v1', ['single', 'single'], [1.85, -1.8], UndergroundLhdBody, 6.8],
  ['underground_dumper', 'underground_dumper-6-wheel-v1', ['single', 'single', 'single'], [2.25, 0.0, -2.25], UndergroundDumperBody, 7.2],
  ['wheeled_excavator', 'wheeled_excavator-4-wheel-v1', ['single', 'single'], [1.7, -1.7], WheeledExcavatorBody, 6.7],
  ['wheel_dozer', 'wheel_dozer-4-wheel-v1', ['single', 'single'], [1.55, -1.55], WheelDozerBody, 6.2],
  ['wheeled_drill_rig', 'wheeled_drill_rig-6-wheel-v1', ['single', 'single', 'single'], [2.2, 0.0, -2.2], WheeledDrillRigBody, 7.0],
  ['wheeled_crane', 'wheeled_crane-6-wheel-v1', ['single', 'single', 'single'], [2.45, 0.0, -2.45], WheeledCraneBody, 7.7],
  ['pneumatic_tyre_roller', 'pneumatic_tyre_roller-8-wheel-v1', ['dual', 'dual'], [1.55, -1.55], PneumaticTyreRollerBody, 5.4],
];

const buildPreset = ([modelKey, layoutKey, fitments, axleXs, Body, extent]) => {
  const wheelRadius = modelKey === 'forklift' ? 0.47 : modelKey === 'pneumatic_tyre_roller' ? 0.6 : 0.68;
  const tyreWidth = modelKey === 'forklift' ? 0.34 : 0.42;
  const halfTrack = modelKey === 'forklift' ? 0.72 : 0.92;
  const dualSpacing = 0.46;
  const wheels = fitments.flatMap((fitment, index) => {
    const placement = {
      axle: index + 1,
      x: axleXs[index],
      radius: wheelRadius,
      width: tyreWidth,
      halfTrack,
      style: 'steel',
    };
    return fitment === 'dual'
      ? dualAxle({ ...placement, spacing: dualSpacing })
      : singleAxle(placement);
  });
  return {
    id: `${modelKey}-standard`,
    silhouette: modelKey,
    renderModelKey: modelKey,
    renderLayoutKey: layoutKey,
    label: `${fitments.length} axle operational layout`,
    layout: layoutOf(fitments),
    wheels,
    camera: {
      position: [extent * 1.05, Math.max(4.2, extent * 0.62), extent * 0.95],
      target: [0, modelKey.includes('drill') || modelKey.includes('crane') ? 1.8 : 1.2, 0],
      minDistance: 5,
      maxDistance: 24,
      fov: 32,
    },
    stage: { extent, contactHeight: wheelRadius * 2 },
    skeleton: 'frame',
    Body,
  };
};

const OPERATIONAL_FLEET_PRESETS = specs.map(buildPreset);

export { OPERATIONAL_FLEET_PRESETS };
